export default __webpack_public_path__ + "6c28ed0f7e1453f98f1bf678937e7676.png";